function getPixelsOutsideViewport() {
  if (window.innerWidth >= 1249) {
    return;
  }

  const element = document.querySelector("[data-scroll-effect]");

  if (!element) {
    return;
  }

  const rect = element.getBoundingClientRect();
  let pixelsOutside = 0;

  // Sprawdzamy, czy górna krawędź elementu znajduje się poza viewportem
  if (rect.top < 0) {
    pixelsOutside = Math.abs(rect.top); // Zliczamy tylko piksele od góry
  }

  // Przesuwamy element tylko wtedy, gdy górna część jest poza widokiem
  if (pixelsOutside > 0) {
    element.style.left = `-${pixelsOutside / 10}%`;
    element.style.top = `-${pixelsOutside / 9}px`;
  } else {
    element.style.left = 0;
    element.style.top = 0;
  }
}

document.addEventListener("scroll", getPixelsOutsideViewport);
